const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
    },
    {
        title: 'Email',
        dataIndex: 'email',
        sorter: true,
    },
    {
        title: 'Lots',
        dataIndex: 'lot',
        sorter: true,
    },
    {
        title: 'Commission',
        dataIndex: 'commissionAmount',
        sorter: true,
    },
    {
        title: 'Transaction Date',
        dataIndex: 'transactionDate',
        sorter: true,
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
        fixed: 'right'
    }
];


export default columns;